const API_URL = {
  FAVORITES_LIST: 'https://orimine-management.fly.dev/api/favorites',
  FAVORITE_LIST_CREATE: 'https://orimine-management.fly.dev/api/favorite-list/create',
  FAVORITE_LIST_DELETE: 'https://orimine-management.fly.dev/api/favorite-list/delete',
  FAVORITES_CREATE: 'https://orimine-management.fly.dev/api/favorites/create',
  FAVORITES_DELETE: 'https://orimine-management.fly.dev/api/favorites/delete',
};

$(document).ready(function () {
  // モーダルの要素を取得
  const $favoriteModal = $('#favorite-modal');
  const $newListModal = $('#new-list-modal');
  const $loginRequiredModal = $('#login-required-modal');
  let currentProductVariantGid = null;

  // ─── 購入制限ヘルパー (Phase D / SKU 別購入制限) ───
  // 戻り値:
  //   { type: 'unlimited' }  → 制限なし (metafield 未設定)
  //   { type: 'blocked' }    → 購入制限中 (metafield=0、追加完全不可)
  //   { type: 'limit', value: N }  → N 単位までキャップ
  function getPurchaseLimit(variantId) {
    const $counter = $(`.counter[data-variant-id='${variantId}']`).first();
    const attr = $counter.attr('data-purchase-limit');
    if (attr === undefined || attr === '' || attr === null) {
      return { type: 'unlimited' };
    }
    const num = parseInt(attr, 10);
    if (!Number.isFinite(num)) return { type: 'unlimited' };
    if (num === 0) return { type: 'blocked' };
    if (num > 0) return { type: 'limit', value: num };
    return { type: 'unlimited' };
  }
  function getCartVariantQuantity(variantId) {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then((r) => r.json())
      .then((cart) => {
        const item = (cart.items || []).find((i) => String(i.id) === String(variantId));
        return item ? item.quantity : 0;
      })
      .catch(() => 0);
  }
  // 購入制限警告モーダルは assets/purchase-limit-modal.js に共通化済 (window.showPurchaseLimitWarning)
  function showLimitWarning(text) {
    if (typeof window.showPurchaseLimitWarning === 'function') {
      window.showPurchaseLimitWarning(text);
    }
  }

  // モーダルを閉じる処理
  $('#favorite-modal button, #new-list-modal button').on('click', function () {
    $favoriteModal.addClass('tw-hidden');
    $newListModal.addClass('tw-hidden');
  });

  // 未ログインモーダルを閉じる処理（× と「閉じる」ボタン）
  $('#login-required-modal').on('click', '.login-required-close', function () {
    $loginRequiredModal.addClass('tw-hidden');
  });

  // モーダルの背景クリックで閉じる処理を追加
  $('#favorite-modal, #new-list-modal, #login-required-modal').on('click', function (e) {
    // モーダルの背景がクリックされた場合のみ閉じる
    // （モーダルのコンテンツ部分をクリックした場合は閉じない）
    if (e.target === this) {
      $(this).addClass('tw-hidden');
    }
  });

  // ─── 入数セグメント (Step 4-B) ───────────────────────────────────────────
  // 現行は variant ごとに完結した購入行を N 段積んでいたので、切替という概念が
  // 無かった。1 セレクタ + 1 購入ブロックにしたため、選択で
  // SKU / 入数 / 税抜 / 単価 / 在庫表示 / 数量上限 を差し替える。
  //
  // 🔴 属性と jQuery の data キャッシュを両方書くこと。
  //    既存コードは `.add-cart-btn[data-variant-id='…']` という属性セレクタと
  //    `$el.data('variant-id')` の両方で variant を引いており、
  //    どちらか片方だけ更新すると、片側が古い variant を掴んだまま動く。
  // 🔴 jQuery の「属性 → data」型変換を再現してから data に書くこと。
  //
  //    jQuery が data-* を型変換するのは **属性から初めて読むときだけ**で、
  //    .data(name, value) で明示的に書いた値は変換されず素通しになる。
  //    そのため、ここで文字列をそのまま渡すと初期ロードと切替後で型が変わる:
  //
  //      初期ロード  data-infinite-preorder="false" → .data() は boolean false
  //      切替後      .data('infinite-preorder','false') → .data() は文字列 "false"
  //
  //    **文字列 "false" は truthy** なので、.plus ハンドラの
  //      if (is_infinite_preorder) { 在庫チェックせず加算 }
  //    が予約商品扱いの枝に入り、**在庫の上限クランプが丸ごと外れていた**
  //    (在庫 8 の variant で + を押し続けると 41 まで伸びた。2026-08-05 実測)。
  //    add_cart / executeAddCart の is_preorder 判定も同じ理由で常に真になり、
  //    追加後のラベルが「予約注文する」に化けていた。
  //
  //    読み出し側 (.plus / add_cart / executeAddCart) は複数あるので、
  //    **書き込み点であるここ 1 箇所**で型を揃えるのが最小の修正になる。
  //    変換規則は jQuery 3.x の内部関数 getData と同一にしてあるため、
  //    初期ロード時と完全に同じ型になる (= 挙動が 1 本化される)。
  function coerceLikeJqueryDataAttr(val) {
    if (typeof val !== 'string') return val;
    if (val === 'true') return true;
    if (val === 'false') return false;
    if (val === 'null') return null;
    // 数値文字列のみ数値化 ("08" や "1e3" は文字列のまま = jQuery と同じ判定)
    if (val === +val + '') return +val;
    return val;
  }
  function setDataAttr($el, name, val) {
    if (val === undefined || val === null || val === '') {
      $el.removeAttr('data-' + name).removeData(name);
    } else {
      // 属性は文字列のまま (属性セレクタ [data-variant-id='…'] が引き続き効く)、
      // data キャッシュだけ jQuery 相当に型変換して書く。
      $el.attr('data-' + name, val).data(name, coerceLikeJqueryDataAttr(val));
    }
  }

  function applyVariantFromSegment($seg) {
    if (!$seg || !$seg.length) return;
    const d = (k) => $seg.attr('data-' + k);
    const variantId = d('variant-id');

    // 表示値
    $('[data-buy-sku]').text(d('sku') || '');
    $('[data-buy-unitqty]').text(d('unit-quantity') || '');
    $('[data-buy-price]').text(d('price') || '');
    const unitPrice = d('unit-price') || '';
    $('[data-buy-unitprice]').text(unitPrice);
    // 入数が未設定の variant は単価を出さない (「円」だけが残らないように)
    $('[data-buy-unitprice-yen]').text(unitPrice ? '円' : '');

    // 在庫状態 + 補足 (Step 4-F で1領域に統合) は variant ごとに描画済み。
    // hidden 属性で出し分ける (クラスの付け外しではなく属性。詳細度で勝つのでレイヤ構成に依存しない)。
    $('.tw-buy-notice-item').prop('hidden', true);
    $(".tw-buy-notice-item[data-buy-notice-for='" + variantId + "']").prop('hidden', false);

    // 数量ステッパー
    const $counter = $('.counter').first();
    setDataAttr($counter, 'variant-id', variantId);
    setDataAttr($counter, 'purchase-limit', d('purchase-limit'));
    $counter.val(1);

    // カートボタン
    const $btn = $('.add-cart-btn').first();
    setDataAttr($btn, 'variant-id', variantId);
    setDataAttr($btn, 'preorder', d('preorder'));
    setDataAttr($btn, 'infinite-preorder', d('infinite-preorder'));
    setDataAttr($btn, 'inventory', d('inventory'));
    setDataAttr($btn, 'is-order-stock', d('is-order-stock'));
    setDataAttr($btn, 'purchase-limit', d('purchase-limit'));
    setDataAttr($btn, 'locked', d('locked'));

    const isPreorder = d('preorder') === 'true';
    const isInfinite = d('infinite-preorder') === 'true';
    // 法人・店舗様限定 (サンプル等) を未ログイン / 法人でないアカウントが選んだとき。
    // Liquid の data-locked と同じ値 (publish_range の判定は Liquid 側にしか無い)。
    const isLocked = d('locked') === 'true';
    // Liquid 側の disabled 条件と同一 (available <= 0 かつ continue でない)。
    // 見た目の「在庫切れ」(data-soldout) とは条件が違うので混ぜない。
    const isSoldOutDisabled = d('out-of-stock') === 'true' && isInfinite === false;

    $btn.removeClass('is-added').toggleClass('is-preorder', isPreorder);
    $btn.prop('disabled', isLocked || isSoldOutDisabled);
    // ロックは「在庫なし」ではないので文言は変えない (理由は入数の直下の案内文)。
    $btn.find('span').text(
      isLocked ? (isPreorder ? '予約注文する' : 'カートに追加') : isSoldOutDisabled ? '在庫なし' : isPreorder ? '予約注文する' : 'カートに追加'
    );
    // 数量ステッパーも一緒に無効にする (見た目は CSS の .tw-buy-actions.is-locked)
    $btn.closest('.tw-buy-actions').toggleClass('is-locked', isLocked);

    // お気に入り
    setDataAttr($('.favorite-btn').first(), 'variant-gid', d('variant-gid'));

    // 選択状態
    $('.tw-unit-seg').attr('aria-pressed', 'false');
    $seg.attr('aria-pressed', 'true');

    // 入数比較表 (variant 2 個以上のときだけ存在。価格ブロックの代わりに表示)
    // のハイライト行をセグメントの選択に連動させる。
    $('[data-compare-row]').removeClass('is-selected');
    $(`[data-compare-row][data-variant-id='${variantId}']`).addClass('is-selected');
  }

  $('.tw-unit-seg').on('click', function () {
    applyVariantFromSegment($(this));
  });

  // ─── ?variant= による入数の初期選択 (2026-08-14) ─────────────────────────
  // お気に入り一覧から「登録した入数が選ばれた状態」で戻ってくるための入口。
  // メール / SNS で URL を共有したときにも同じように効く。
  //
  // 🔴 ここでやるのは applyVariantFromSegment を 1 回呼ぶことだけ。
  //    あの関数が SKU / 入数 / 税抜 / 単価 / 在庫表示 / 補足 / 数量上限 /
  //    purchase_limit / カートボタンの活性と文言 / お気に入りの variant GID /
  //    比較表のハイライトを **まとめて** 更新するので、項目ごとの追従処理は要らない。
  //    切替ロジックを二重に持たない = クリック経由と URL 経由で挙動がズレない。
  //
  // 🔴 一致するセグメントが無いときは「何もしない」= Liquid が描いた既定の選択
  //    (先頭の買える variant) のまま。次のどれも同じ扱い:
  //      ・存在しない / 不正な variant ID     … DOM に一致が無い
  //      ・他商品の variant ID                 … 同上
  //      ・非公開の variant                    … Liquid がセグメントごと描いていない
  //
  //    「会社様・店舗様アカウントのみに公開」の variant は、2026-10-05 から
  //    未ログイン / 法人でないアカウントにもグレーのセグメントとして出している
  //    (サンプルの取扱いがあることを伝えるため)。したがって B2B 限定の入数を
  //    お気に入りから開くと、そのセグメントが選ばれた状態 = カートボタンが無効で
  //    入数の直下に「法人・店舗様でログイン・会員登録後に購入できます」が出る状態になる。
  //    以前の「黙って既定の選択に落ちる」より理由が分かる分だけ良くなる。
  //    詳細 = docs/investigation-favorite-variant.md §E-3 / §H
  (function selectVariantFromUrl() {
    var raw;
    try {
      raw = new URLSearchParams(window.location.search).get('variant');
    } catch (e) {
      return; // URLSearchParams 非対応環境では既定の選択のまま
    }
    if (!raw || !/^\d+$/.test(raw)) return; // 数値以外はセレクタに渡さない
    var $seg = $(".tw-unit-seg[data-variant-id='" + raw + "']");
    if (!$seg.length) return; // 該当なし = 既定の選択のまま
    applyVariantFromSegment($seg.first());
  })();

  // マイナス・プラスボタン
  $('.minus').click(function () {
    var $input = $(this).parent().find('input');
    var variantId = $input.data('variant-id');
    var count = parseInt($input.val()) - 1;
    count = count < 1 ? 1 : count;
    $input.val(count);
    $input.change();
    return false;
  });
  $('.plus').click(function () {
    // 法人・店舗様限定を選んでいる間は数量を動かさない (CSS でも押せなくしてある)
    if ($(this).closest('.tw-buy-actions').hasClass('is-locked')) return false;
    var $input = $(this).parent().find('input');
    var variantId = $input.data('variant-id');
    var button = $(`.add-cart-btn[data-variant-id='${variantId}']`);
    var is_infinite_preorder = button.data('infinite-preorder');
    var inventory = button.data('inventory');
    var pl = getPurchaseLimit(variantId);
    var currentVal = parseInt($input.val());
    var nextVal = currentVal + 1;

    // 購入制限: blocked (=0) → 増加完全ブロック
    if (pl.type === 'blocked') {
      showLimitWarning('現在購入制限中のため、こちらの商品はご購入いただけません。');
      return false;
    }
    // 購入制限: limit (>0) → N 単位までキャップ
    if (pl.type === 'limit' && nextVal > pl.value) {
      showLimitWarning(`この商品はお一人様 ${pl.value} 単位までのご購入とさせていただいております。`);
      return false;
    }

    // 予約注文または受注生産の場合は在庫制限なし (購入制限のみ適用)
    if (is_infinite_preorder) {
      $input.val(nextVal);
    } else {
      // 通常商品の場合は在庫数まで
      if (currentVal < inventory) {
        $input.val(nextVal);
      }
    }

    $input.change();
    return false;
  });

  // 数量入力フィールドを直接編集できないようにする
  $('.counter').on('keydown paste mousewheel', function (e) {
    e.preventDefault();
    return false;
  });
  // 上下矢印キーでの編集も禁止
  $('.counter').on('mousedown', function (e) {
    if (e.target.type === 'number') {
      e.preventDefault();
      return false;
    }
  });

  // カートに追加
  $('.add-cart-btn').each(function () {
    $(this).on('click', function () {
      add_cart(this);
    });
  });

  const add_cart = (element) => {
    const variantId = $(element).data('variant-id');
    const quantity = $(`.counter[data-variant-id='${variantId}']`).first().val();

    // ボタンのテキスト
    const button = $(`.add-cart-btn[data-variant-id='${variantId}']`);
    const button_span = button.find('span');
    const is_preorder = button.data('preorder');
    const is_infinite_preorder = button.data('infinite-preorder');
    const inventory = button.data('inventory');

    // 法人・店舗様限定は追加しない。ボタンは disabled なので通常ここには来ないが、
    // disabled を外されても通さない (data は jQuery の型変換で boolean true)。
    if (button.data('locked') === true) return;

    // ─── 購入制限チェック ───
    const pl = getPurchaseLimit(variantId);

    // blocked (=0) → 追加完全不可
    if (pl.type === 'blocked') {
      showLimitWarning('現在購入制限中のため、こちらの商品はご購入いただけません。');
      return;
    }

    // limit (>0) → 合算チェック (既存カート内数量 + 今回追加数量)
    if (pl.type === 'limit') {
      const limit = pl.value;
      const qtyInt = parseInt(quantity, 10) || 0;
      getCartVariantQuantity(variantId).then((cartQty) => {
        if (cartQty + qtyInt > limit) {
          const remaining = Math.max(0, limit - cartQty);
          const msg =
            remaining === 0
              ? `この商品はお一人様 ${limit} 単位までのご購入とさせていただいております。\n既にカートに ${cartQty} 単位入っているため、これ以上追加できません。`
              : `この商品はお一人様 ${limit} 単位までのご購入とさせていただいております。\n既にカートに ${cartQty} 単位入っているため、あと ${remaining} 単位まで追加可能です。`;
          showLimitWarning(msg);
          return; // 追加中止
        }
        // 制限内 → 実際の追加処理に進む
        executeAddCart(variantId, quantity, button, button_span, is_preorder, is_infinite_preorder, inventory);
      });
      return;
    }

    // 購入制限なし (unlimited) → 直接追加
    executeAddCart(variantId, quantity, button, button_span, is_preorder, is_infinite_preorder, inventory);
  };

  const executeAddCart = (variantId, quantity, button, button_span, is_preorder, is_infinite_preorder, inventory) => {
    // テキスト変更してdisabledにする
    button_span.text('追加中...');
    button.attr('disabled', true);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity,
          },
        ],
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        // カート内の商品数を更新 (2026-07-23: 即時反映を確実にする)
        //   - 旧実装は DOM の数字に加算するだけだったため、空カート時は
        //     バッジ要素自体が存在せず (my-header.liquid が if で出し分けていた)
        //     リロードまでバッジが出なかった。
        //   - バッジは常時描画に変更済。ここでは tw-hidden を外して表示し、
        //     件数は /cart.js の実値で上書きする (加算のズレも起きない)。
        const quantityInt = Number(quantity) || 0;
        const optimisticAmount =
          (parseInt($('.cart-amount').first().text()) || 0) + quantityInt;
        $('.cart-amount').text(optimisticAmount.toString());
        $('.cart-badge').removeClass('tw-hidden');
        fetch('/cart.js', { credentials: 'same-origin' })
          .then((r) => r.json())
          .then((cart) => {
            const count = Number(cart.item_count) || 0;
            $('.cart-amount').text(count.toString());
            if (count > 0) {
              $('.cart-badge').removeClass('tw-hidden');
            } else {
              $('.cart-badge').addClass('tw-hidden');
            }
          })
          .catch(() => {
            /* 取得失敗時は上の楽観更新の値を維持 */
          });

        // 1秒間「追加しました」と表示させた後に、「カートに追加」に戻す
        button_span.text('追加しました');
        // Step 4-B: 色は span への inline style ではなくボタンのクラスで持つ。
        // ボタン自体が tw-primary-btn (塗り) になったため、span に背景を当てると
        // 二重になり、:disabled / :hover の表現とも噛み合わない。
        button.addClass('is-added');

        // 在庫を再計算する
        const newInventory = inventory - quantity;
        button.data('inventory', newInventory);
        button.attr('data-inventory', newInventory);
        // 入数を切り替えて戻ってきたときに古い在庫数へ巻き戻らないよう、
        // セグメント側にも書き戻す (セグメントが variant ごとの値の持ち主)
        $(".tw-unit-seg[data-variant-id='" + variantId + "']")
          .attr('data-inventory', newInventory)
          .data('inventory', newInventory);

        // 在庫表示を更新
        $(`.inventory[data-variant-id='${variantId}']`).text(`在庫数：${newInventory}`);

        // カウンターを1に戻す
        $(`.counter[data-variant-id='${variantId}']`).val(1);

        setTimeout(function () {
          // 追加から 0.8 秒のあいだに別の入数へ切り替えていたら何もしない。
          // ボタンの状態は切替時に applyVariantFromSegment が決め直している。
          // ここで上書きすると、切替先が法人・店舗様限定や在庫切れでも
          // ボタンが押せる状態に戻ってしまう。
          if (String(button.attr('data-variant-id')) !== String(variantId)) {
            button.removeClass('is-added');
            return;
          }
          button.removeClass('is-added');
          if (is_preorder) {
            if (!is_infinite_preorder && newInventory <= 0) {
              button_span.text('在庫なし');
              button.attr('disabled', true);
            } else {
              button_span.text('予約注文する');
              button.addClass('is-preorder');
              button.attr('disabled', false);
            }
          } else {
            if (newInventory > 0) {
              button_span.text('カートに追加');
              button.attr('disabled', false);
            } else {
              button_span.text('在庫なし');
              button.attr('disabled', true);
            }
          }
        }, 800);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // お気に入りボタンのクリックイベント
  $('.favorite-btn').on('click', function () {
    const customerGid = $(this).data('customer-gid');
    if (!customerGid) {
      $loginRequiredModal.removeClass('tw-hidden');
      return;
    }

    $favoriteModal.removeClass('tw-hidden');

    const $btn = $(this);
    currentProductVariantGid = $btn.data('variant-gid'); // 商品IDを保存

    // お気に入りリストを取得
    fetch(`${API_URL.FAVORITES_LIST}?customer_gid=${encodeURIComponent(customerGid)}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          const $favoriteList = $('#favorite-list').empty();

          if (data.favoriteLists.length === 0) {
            $favoriteList.append(`
              <li class="tw-py-8 tw-text-center tw-text-gray-500 tw-text-14">
                お気に入りリストがありません
              </li>
            `);
          } else {
            // 既存のリストを表示
            data.favoriteLists.forEach((list) => {
              const isAlreadyAdded = list.items.some((item) => item.shopifyVariantId === currentProductVariantGid);
              const buttonText = isAlreadyAdded ? '追加済み' : 'このリストに追加';
              const buttonDisabled = isAlreadyAdded ? 'disabled' : '';

              $favoriteList.append(`
                <li class="tw-border-b tw-border-gray-200 tw-py-4 tw-px-4 tw-flex tw-justify-between tw-items-center tw-gap-4">
                  <span class="tw-truncate tw-max-w-[200px]">${list.title}</span>
                  <button 
                    type="button" 
                    class="add-to-list-btn tw-bg-primary tw-text-white tw-px-4 tw-py-2 tw-text-12 tw-rounded-lg tw-whitespace-nowrap"
                    data-list-id="${list.id}"
                    ${buttonDisabled}
                  >${buttonText}</button>
                </li>
              `);
            });
          }

          // モーダルを表示
          $favoriteModal.removeClass('tw-hidden');
        } else {
          alert('お気に入りリストの取得に失敗しました');
        }
      })
      .catch((err) => {
        console.error(err);
        alert('エラーが発生しました');
      });
  });

  // 新規リスト作成フーダルを開く
  $('#open-new-list-modal').on('click', function () {
    $favoriteModal.addClass('tw-hidden');
    $newListModal.removeClass('tw-hidden');
  });

  // 新規リスト作成フーダルから戻るボタン
  $('#back-to-favorite-modal').on('click', function () {
    $newListModal.addClass('tw-hidden');
    $favoriteModal.removeClass('tw-hidden');
  });

  // 新規リスト作成フォームの送信処理
  $('#new-list-form').on('submit', function (e) {
    e.preventDefault();

    const title = $('#new-list-name').val().trim();
    const customerGid = $('.favorite-btn').data('customer-gid');

    if (!customerGid) {
      alert('ログインが必要です');
      return;
    }

    fetch(API_URL.FAVORITE_LIST_CREATE, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        customerGid: customerGid,
        title: title,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          $('#new-list-name').val(''); // フォームをクリア
          $newListModal.addClass('tw-hidden'); // 新規リスト作成モーダルを閉じる

          // お気に入りリストを再読み込みして表示
          fetch(`${API_URL.FAVORITES_LIST}?customer_gid=${encodeURIComponent(customerGid)}`)
            .then((res) => res.json())
            .then((data) => {
              if (data.success) {
                const $favoriteList = $('#favorite-list').empty();
                data.favoriteLists.forEach((list) => {
                  $favoriteList.append(`
                    <li class="tw-border-b tw-border-gray-200 tw-py-4 tw-px-4 tw-flex tw-justify-between tw-items-center tw-gap-4">
                      <span class="tw-truncate tw-max-w-[200px]">${list.title}</span>
                      <button 
                        type="button" 
                        class="add-to-list-btn tw-bg-primary tw-text-white tw-px-4 tw-py-2 tw-text-12 tw-rounded-lg tw-whitespace-nowrap"
                        data-list-id="${list.id}"
                      >このリストに追加</button>
                    </li>
                  `);
                });
                $favoriteModal.removeClass('tw-hidden'); // お気に入りリストモーダルを表示
              }
            });
        } else {
          alert(data.message || 'リストの作成に失敗しました。');
        }
      })
      .catch((err) => {
        console.error(err);
        alert('エラーが発生しました。');
      });
  });

  // お気に入りリストへの追加ボタンのクリックイベント
  $(document).on('click', '.add-to-list-btn', function () {
    const $button = $(this);
    const favoriteListId = $button.data('list-id');
    const productVariantGid = currentProductVariantGid;

    // ボタンを「追加中」に変更
    $button.text('追加中...').prop('disabled', true);

    fetch(API_URL.FAVORITES_CREATE, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        favoriteListId: favoriteListId,
        productVariantGid: productVariantGid,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          $button.text('追加しました');

          // 1秒後に「このリストに追加」に戻す
          setTimeout(() => {
            $button.text('追加済み');
          }, 1000);
        } else {
          // エラーメッセージを表示して元の状態に戻す
          alert(data.message || 'お気に入りリストへの追加に失敗しました');
          $button.text('このリストに追加').prop('disabled', false);
        }
      })
      .catch((err) => {
        console.error(err);
        alert('エラーが発生しました');
        $button.text('このリストに追加').prop('disabled', false);
      });
  });
});
